import { Box, Button, Flex, IconButton, VStack } from '@chakra-ui/react';
import { Close } from '@time-line/components/icons';
import type { FullscreenPopup } from 'types/cms/Globals';

import { TextContent } from './TextContent';

type VideoContentProps = Pick<
  FullscreenPopup,
  'overlineText' | 'title' | 'link'
> & {
  onClose: (action?: 'click' | 'close', url?: string) => void;
};

export function VideoContent({
  overlineText,
  title,
  link,
  onClose,
}: VideoContentProps) {
  return (
    <Box w="100%" h="100%">
      <Flex
        w={{ base: '100%', md: '50%' }}
        h="100%"
        px={{ base: 'sm', md: 'm' }}
        pt={{ base: '3xl', md: 0 }}
        alignItems={{ base: 'start', md: 'center' }}
        justifyContent="center"
      >
        <VStack pos="relative" gap={0} maxW="480px" px={0}>
          <IconButton
            pos="fixed"
            top={{ base: 'sm', md: 'm' }}
            right={{ base: 'sm', md: 'm' }}
            boxSize="44px"
            variant="primary"
            borderRadius="full"
            colorScheme="white"
            onClick={() => onClose('close')}
            aria-label="Close"
          >
            <Close boxSize="xs" />
          </IconButton>
          <TextContent overlineText={overlineText} title={title} />
          <Button
            as="a"
            mt={{ base: 'xs', md: 'm' }}
            href={link.href}
            onClick={() => onClose('click', link.href)}
          >
            {link.title}
          </Button>
        </VStack>
      </Flex>
    </Box>
  );
}
